module.exports = __webpack_public_path__ + "static/img/home_new.e57691b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_new.jpg
// module id = Dq22
// module chunks = 0